import { bus } from "@/bus";

const backgroundTaskModule = {
  namespaced: true,
  state: {
    progressPercent: 0,
    progressName: null,
    progressTitle: "",
    nameTranslations: {
      "calculate-asa": "ASA Dialoge berechnen",
      "calculate-zipcode-cache": "Cache für dynamische PLZ berechnen"
    },
    activeBackgroundTasks: []
  },
  mutations: {
    update(state, data) {
      let task;

      if (data.percent < 100) {
        if (
          (task = state.activeBackgroundTasks.find(item => {
            return item.name === data.name;
          }))
        ) {
          // Update existing task
          task.percent = data.percent;
        } else {
          // Add new task
          state.activeBackgroundTasks.push({
            name: data.name,
            percent: data.percent
          });
        }
      } else if (
        (task = state.activeBackgroundTasks.find(item => {
          return item.name === data.name;
        }))
      ) {
        // Task completed, remove it from list
        state.activeBackgroundTasks.splice(
          state.activeBackgroundTasks.indexOf(task),
          1
        );
      }

      if (state.activeBackgroundTasks.length > 0) {
        state.progressPercent = state.activeBackgroundTasks[0].percent;
        state.progressName = state.activeBackgroundTasks[0].name;
        state.progressTitle =
          state.nameTranslations[state.activeBackgroundTasks[0].name] ===
          undefined
            ? state.activeBackgroundTasks[0].name
            : state.nameTranslations[state.activeBackgroundTasks[0].name];
      } else {
        state.progressPercent = 0;
        state.progressName = null;
        state.progressTitle = "";
      }

      bus.$emit("background-task-update", {
        percent: state.progressPercent,
        title: state.progressTitle,
        name: state.progressName,
        active: state.progressName !== null
      });
    }
  },
  getters: {
    running: state => name => {
      return Boolean(
        state.activeBackgroundTasks.find(item => {
          return item.name === name;
        })
      );
    }
  }
};

export default backgroundTaskModule;
